import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --black: #000000;
    --white: #FFFFFF;
    --color-primary: #dba14a;
    --color-primary-light: #dba14a52;
    --color-secondary: #245110;
    --color-bg: #f5ede3;
    --default-font-size: 1rem;
    --spacer: 1rem;
  }

  html, body {
    font-size: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: var(--color-bg);
  }

  #___gatsby,
  #gatsby-focus-wrapper {
    min-height: 100vh;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
  }

  img {
    max-width: 100%;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }
`;

export default GlobalStyles;
